module.exports = __webpack_public_path__ + "static/img/bg.4c37441a.png";